<template>
  <Layout :tituloPagina="'Sistema | Log'">
    <div class="text-end mb-2">
      <span class="badge bg-secondary bg-gradient font-size-12">
        {{total_logs.toLocaleString('en-US')}} total logs
      </span>
    </div>
    <div class="card">
      <div class="card-header justify-content-between d-flex align-items-center">
        <h4 class="card-title">
          Log de eventos
        </h4>
        <div>
          <div class="dropdown">
            <a
              class="dropdown-toggle"
              href="javascript: void(0);"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <eva-icon
                name="more-horizontal-outline"
                data-eva-width="20"
                data-eva-height="20"
                :class="{
                  'fill-dark': $store.state.layout.layoutMode == 'light',
                  'fill-white': $store.state.layout.layoutMode == 'dark'
                }"
              ></eva-icon>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a
                  href="#"
                  class="dropdown-item"
                  onclick="return false"
                  @click="eliminarLog()"
                  v-if="!bandera_spinner"
                >
                  <i class="mdi mdi-eraser text-success"></i>
                  Limpiar el log
                </a>
                <span class="dropdown-item disabled" v-if="bandera_spinner">
                  <i class="mdi mdi-concourse-ci mdi-spin"></i>
                  Limpiar el log
                </span>
              </li>
              <li>
                <a
                  class="dropdown-item" href="#"
                  onclick="return false;" @click="cerrar()"
                >
                  <i class="mdi mdi-close text-dark"></i>
                  Cerrar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div id="scroll" class="table-responsive" style="height: 620px">
          <table class="table table-nowrap align-middle" id="tabla-log">
            <thead>
              <tr>
                <th style="width: 50px;">Fecha</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.posicion">
                <td>{{ log.tiempo }}</td>
                <td>{{ log.message }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="text-right">
      <div class="btn-group">
        <button @click="cerrar()" class="btn btn-secondary">
          <i class="mdi mdi-chevron-left"></i>
          Atras
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="eliminarLog()"
          :disabled="bandera_spinner"
        >
          <i
            class="mdi"
            :class="!bandera_spinner ? 'mdi-eraser' : 'mdi-concourse-ci mdi-spin'"
          ></i>
          Limpiar el log
        </button>
      </div>
    </div>

    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue"
import LogSrv from "@/services/LogSrv"
import Swal from 'sweetalert2'

export default {
  name: 'sistemaLog',
  components:{ Layout },
  data: function() {
    return {
      bandera_spinner: false,
      total_logs: 0,
      logs: [],
      primerCarga: true,
    }
  },
  created: function(){
    var self = this

    self.refrescarLogs()
  },
  watch: {
    logs() {
      this.$nextTick(() => {
        setTimeout(() => {
          const contenedor = document.getElementById('scroll');
          if (!contenedor) return

          if (this.primerCarga) {
            // Scroll forzado en la primera carga
            contenedor.scrollTo({
              top: contenedor.scrollHeight,
              behavior: 'auto' // sin animación en la primera carga
            })
            this.primerCarga = false
          } else {
            // Scroll suave solo si el usuario está abajo
            const estaCasiAbajo = contenedor.scrollHeight - contenedor.scrollTop - contenedor.clientHeight < 50
            if (estaCasiAbajo) {
              contenedor.scrollTo({
                top: contenedor.scrollHeight,
                behavior: 'smooth'
              })
            }
          }
        }, 200)
      })
    }
  },
  methods: {
    eliminarLog:function() {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "Eliminación de log",
        html: `¿Estás seguro de eliminar el log?`,
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          LogSrv.eliminar().then(response => {
            swal.fire("Eliminado!", "Se eliminó correctamente", "success");
            self.refrescarLogs()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = 'No se pudo eliminar el log'
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },
    cerrar: function() {
      this.$router.go(-1)
    },

    refrescarLogs: function() {
      var self = this

      LogSrv.logsJSON().then(response => {
        self.logs = response.data.logs
        self.total_logs = response.data.total_logs
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'no se pudieron cargar los logs'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    }
  }
}
</script>